export class Questionnaire {
    question: string = '';
    answer: string = '';
}

export class CovidQuestionnaireInput {    
    questionnaireList = [];
    ldc: string = '';
    kmiUrlCode: string = '';
    orderNumber: string = '';
    orderType: string = '';
    premisesNumber: string = '';    
    logReferenceID: string = '';
    portalTypeID: number = 0;    
    emailToList: string = '';
}
export class CovidQuestionnaireOutput {
    isQuestionnaireHasYes: boolean = false;
    questionnaireQnAnswerList = [];
}